
<template>
  <div class="antiInfo">
    <div
      class="aImg"
      :style="{
        background: chinStatus
          ? 'url(' + require('../assets/images/撕毁防伪.png') + ')'
          : 'url(' + require('../assets/images/防伪.png') + ')',
        'background-repeat': 'no-repeat',
        'background-size': '100%',
      }"
    >
      <!-- <img
        src="../assets/images/撕毁防伪.png"
        alt=""
        v-if="item.msgItems[0].op.op.chinStatus"
      />
      <img src="../assets/images/防伪.png" alt="" v-else /> -->
      <!-- 防伪信息 -->
      <div class="info" @click="hInfo(list)">
        <span class="wen">查看防伪溯源记录</span>
        <span class="tu"
          ><img src="../assets/images/箭头.png" alt="" class="img"
        /></span>
      </div>
      <!-- 线 -->
      <div
        class="line"
        :style="{
          borderColor: chinStatus ? '#FA5151' : '#26907A;',
        }"
      ></div>
      <!-- 状态 -->
      <div class="state">
        <div
          class="bgImg"
          :style="{
            background: chinStatus
              ? 'url(' + require('../assets/images/组 23165.png') + ')'
              : 'url(' + require('../assets/images/完好框.png') + ')',
            'background-repeat': 'no-repeat',
            'background-size': '100%',
          }"
        >
          <div
            class="title"
            :style="{
              color: chinStatus ? '#FA5151' : '#26907A;',
            }"
          >
            {{ falg == 2 ? "芯片状态" : "NFC验证次数" }}
          </div>
          <div
            v-if="falg == 2"
            class="title2"
            :style="{
              color: chinStatus ? '#FA5151' : '#26907A;',
            }"
          >
            {{ chinStatus ? "撕毁" : "完好" }}
          </div>
          <div
            v-if="falg == 1"
            class="title3"
            :style="{
              color: '#26907A;',
            }"
          >
            {{ list.length }}
          </div>
        </div>
      </div>
      <div class="line2"></div>
    </div>

    <!-- 区块链标识： -->
    <!-- <div class="goods-characteristic">
                <div class="goods-characteristic-inner" :style="{ borderColor: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
                  <span @click="toBlockChain(item)" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
                    区块链标识：{{ item.msgItems[0].txid }}</span>
               </div>
             </div> -->
    <div class="n-info">
      <div class="num" v-if="falg == 2">
        当前验证次数
        <div class="n-text">{{ list.length }}</div>
      </div>
      <div class="createdDate">
        首次访问时间
        <div class="n-text">{{ dqTime | formant }}</div>
      </div>
      <div class="newDate">
        当前访问时间
        <div class="n-text">{{ scTime | formant }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
import { Image as VanImage } from "vant";
Vue.use(Popup);
Vue.use(Toast);
Vue.use(VanImage);
export default {
  props: {
    fwInfo: Object,
  },
  watch: {
    fwInfo(curVal, oldVal) {
      console.log(oldVal, "oldVal");
      if (curVal) {
        this.falg = localStorage.getItem("falg");

        // this.temInfo = curVal;
        console.log(this.fwInfo, "oldVal");
        // console.log(JSON.parse(this.fwInfo.data_list[0].msgItems));
        this.list = this.fwInfo.data_list[0].msgItems;
        this.dqTime = this.list[0].ts;
        this.scTime = this.list.at(-1).ts;
        console.log(this.list, "list");
        this.chinStatus = JSON.parse(this.list[0].op.op).chinStatus;
        console.log(this.chinStatus);
      }
    },
  },
  data() {
    return {
      listDataAll: [],
      list: [],
      list2: null,
      falg: "",
      bgDef: "撕毁防伪.png",
      bgDef2: "防伪.png",
      chinStatus: "",
      dqTime: "",
      scTime: "",
    };
  },
  created() {},
  mounted() {
    // this.listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
    // console.log(this.listDataAll, "this.listDataAll");
    // this.list = this.listDataAll.filter(
    //   (item) => item.trace_name === "防伪信息"
    // );
    // this.chinStatus = this.list[0].msgItems[0].op.op.chinStatus;
    // console.log("fffffffffffff", this.list);
    // this.list2 = JSON.parse(window.localStorage.getItem("reData"));
    // console.log(this.falg, "falg");
  },
  methods: {
    hInfo(item) {
      console.log(item, "item");
      // this.$router.push(`./antiInfo?ts=${item[0].ts}&txid=${item[0].txid}`);
      this.$router.push({
        path: "./antiInfo",
        query: {
          item: JSON.stringify(item), //先转为字符串
        },
      });
    },
    toBlockChain(item) {
      console.log(item);
      this.$router.push(`/Look?ts=${item[0].ts}&txid=${item[0].txid}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.antiInfo {
  width: 696px;
  height: 532px;
  background-color: #fff;
  margin-bottom: 20px;
  .aImg {
    padding-top: 26px;
    width: 100%;
    height: 376px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .info {
    margin-left: 48px;
    .wen {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #000000;
      opacity: 1;
    }
    .tu {
      width: 14px;
      height: 22px;
      margin-left: 14px;
      .img {
        max-height: 21px;
        max-width: 22px;
      }
    }
  }
  .n-info {
    margin-left: 55px;
    margin-top: 20px;

    .num {
      width: 144px;
      height: 34px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #919ab1;
      opacity: 1;
      margin-bottom: 18px;
      margin-top: -30px;
    }
    .createdDate {
      // width: 144px;
      // height: 34px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #919ab1;
      opacity: 1;
      margin-bottom: 18px;
    }
    .newDate {
      // width: 144px;
      // height: 34px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #919ab1;
      opacity: 1;
    }
    .n-text {
      width: 300px;
      height: 34px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #000000;
      opacity: 1;
      margin-left: 240px;
    }
  }
  .line2 {
    width: 514px;
    height: 0px;
    border: 2px dashed #dbdee6;
    opacity: 1;
    margin-left: 60px;
  }
  .line {
    margin-top: 28px;
    margin-left: 48px;
    width: 344px;
    height: 0px;
    border: 1px solid #68b2a2;
    opacity: 1;
  }
  .state {
    margin-left: 60px;
    margin-top: 58px;
    .bgImg {
      display: flex;
      text-align: center;
      width: 317px;
      height: 160px;
      background-size: 100%;
      background-repeat: no-repeat;
      padding-left: 40px;
      padding-top: 50px;
    }
    .title {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #26907a;
      opacity: 1;
      // width: 112px;
      height: 40px;
      border-left: 0;
    }
    .title2 {
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #269079;
      opacity: 1;
      width: 96px;
      height: 66px;
    }
    .title3 {
      font-size: 58px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #269079;
      opacity: 1;
      width: 96px;
      height: 66px;
    }
    .text1 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #fff;
      opacity: 1;
      width: 238px;
      height: 44px;
      background: #96c9bf;
      border-radius: 10px;
    }
    .text2 {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #fff;
      opacity: 1;
      margin-left: -7px;
    }
    .time {
      width: 250px;
      height: 28px;
      margin-left: -105px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #9da5b2;
      opacity: 1;
    }
  }
  .goods-characteristic {
    width: 542px;
    //   padding: 48px 20px;
    margin: 0 auto;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      // height: 62px;
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .Photo {
    position: relative;
    width: 640px;
    height: 188px;

    margin-top: 10px;
    .adv {
      position: absolute;
      width: 66px;
      height: 34px;
      background: #000000;
      opacity: 0.38;
      border-radius: 0px;
      right: 0;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 32px;
      color: #ffffff;
      opacity: 1;
      text-align: center;
    }
  }
  .Photo2 {
    width: 640px;
    height: 188px;

    margin-top: 10px;
  }
}
</style>